/*
 * MM - Newsletter (quiz) : construit dynamiquement le champ contact[tags]
 * à partir des cases "préoccupation beauté" cochées par le client, avant
 * l'envoi du formulaire d'inscription (tag "newsletter" + un tag par case cochée).
 */
(function () {
  function setup(section) {
    var form = section.querySelector('.mm-newsletter-quiz__form');
    var tagsInput = section.querySelector('[data-mm-newsletter-quiz-tags]');
    if (!form || !tagsInput) return;

    var baseTags = (tagsInput.value || '')
      .split(',')
      .map(function (tag) { return tag.trim(); })
      .filter(Boolean);

    form.addEventListener('submit', function () {
      var checked = section.querySelectorAll('.mm-newsletter-quiz__pill-input:checked');
      var tags = baseTags.slice();

      checked.forEach(function (input) {
        if (input.value && tags.indexOf(input.value) === -1) {
          tags.push(input.value);
        }
      });

      tagsInput.value = tags.join(', ');
    });
  }

  function init() {
    var sections = document.querySelectorAll('[data-mm-newsletter-quiz]');
    sections.forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
